import "./CoursesList.css";

import {useState} from 'react';


const possibleGrades = ["AA", "BA", "BB", "CB", "CC", "DC", "DD", "FD", "FF", "M", "T", "G", "K", "DZ", "S"];

const calculateGPA = courses => {
	let total = 0.0;

	courses.forEach(course => {
		switch (course.courseGrade) {
			case "AA":
				total += 4;
				break;
			case "BA":
				total += 3.5;
				break;
			case "BB":
				total += 3;
				break;
			case "CB":
				total += 2.5;
				break;
			case "CC":
				total += 2;
				break;
			case "DC":
				total += 1.5;
				break;
			case "DD":
				total += 1;
				break;
			case "FD":
				total += 0.5;
				break;
			default:
				break;
		}
	});

	return Number((total / courses.length).toFixed(2));
};

export default function CoursesList({ user, getUserInfo }) {

    const [refresh, setRefresh] = useState(false);

    const [isAddingSemester, setIsAddingSemester] = useState(false);

	const [loading, setLoading] = useState(false);


    const toggleCourseAddition = (semester) => {

        semester.isAdding = !semester.isAdding;
        setRefresh(!refresh);

    }

    const addCourse = async (event, semester) => {

        setLoading(true);

		event.preventDefault();

		const requestObj = {
			semester,
			courseCode: event.target.courseCode.value,
			courseGrade: event.target.courseGrade.value,
		}

		try {

			const response = await fetch(process.env.REACT_APP_ROOT_URL + "/add/course", {
				method: "POST",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					"x-auth-token": localStorage.getItem("course-tracker-token")
				},
				body: JSON.stringify(requestObj),
			})

			if(!response.ok) {
				const txt = await response.text();
				throw new Error(txt);
			}

			await getUserInfo();

			setLoading(false);


		} catch (err) {
			setLoading(false);
		}
    }


	const deleteCourse = async (semIndex, courseIndex) => {

		setLoading(true);

		const requestObj = {courseIndex: courseIndex+1, semIndex: semIndex+1};

		try {

			const response = await fetch(process.env.REACT_APP_ROOT_URL + `/delete/`, {
				method: "POST",
				mode: "cors",
				headers: {
					"Content-Type" : "application/json",
					"x-auth-token" : localStorage.getItem("course-tracker-token")
				},

				body: JSON.stringify(requestObj)
			})

			if(!response.ok) {

				const err = await response.text();

				throw new Error(err);

			}

			await getUserInfo();

			setLoading(false);


			
		} catch (err) {

			console.log(err.message)
			setLoading(false);

		}

	}

	const addSemester = async (event) => {

		setLoading(true);

		event.preventDefault();

		try {

			const response = await fetch(process.env.REACT_APP_ROOT_URL + "/add/semester", {
				method: "POST",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					"x-auth-token": localStorage.getItem("course-tracker-token")
				},
				body: JSON.stringify({
					name: event.target.semesterName.value,
				})
			})

			if(!response.ok) {
				const txt = await response.text();
				throw new Error(txt);
			}

			await getUserInfo();

			setLoading(false);
			setIsAddingSemester(false);

		} catch(err) {
			console.log(err);
			setLoading(false);
		}

	}

	return (

		<div id="coursesListTopContainer">
			
		<div id="coursesListLoadingOverlay" className={!loading ? "hidden" : ""}>
			<h1 id="coursesListLoadingOverlay-title">Waiting for Database...</h1>
		</div>

		<div id="coursesList">
			{user.marks.map((semester, semIndex) => (
				<div key={"sem" + semIndex} className="semester">
					<div className={"semesterBanner " + (semIndex === 0 ? "topBanner" : "")}>
						<p className="semesterTitle">{ semester.name ? semester.name : "Semester "+ (semIndex+1)}</p>

                        <div className="leftSideSemesterBanner">
                            {!semester.isAdding && <button className="addCourseButton btn" onClick={() => toggleCourseAddition(semester)} > {!semester.isAdding ? "Add Course" : "Cancel"} </button>}
                            
                            <p className="GPA"> GPA: {calculateGPA(semester.courses)}</p>
                        </div>

					</div>

					{semester.courses.map((course, courseIndex) => (
                        <div key={"sem"+semIndex+"c"+courseIndex} className="course">
                            <p className="courseCode">{course.courseCode}</p>

                            <div className="courseLeft">

								<p className="courseGrade"> {course.courseGrade} </p>
								<button className="deleteCourseButton btn" onClick={() => deleteCourse(semIndex,courseIndex)}> Delete </button>
							</div>
						</div>
                    ))}

                    {semester.isAdding && 
                        <form className="course" onSubmit={(event) => addCourse(event, semIndex)}>
                            <input name="courseCode" className="courseCodeInput" placeholder="Course Code" required/>
                            <select name="courseGrade" className="courseGradeInput">
								{possibleGrades.map((grade, gradeIndex) => (
									<option key={"grade"+gradeIndex} value={grade}>{grade}</option>
								))}
							</select>
                            <button type="button" className="cancelAdditionButton btn" onClick={() => toggleCourseAddition(semester)} > Cancel </button>
                            <button type="submit" className="submitAdditionButton btn"> Add </button>
                        </form>
                        }
				</div>
			))}
			{isAddingSemester &&
			<div className="semester">
				<form className="semesterBanner" onSubmit={(e) => addSemester(e)}>
					<input type="text" name="semesterName" id="semesterNameInput" className="semesterTitle" />

					<button type="button" className="cancelAdditionButton margin-left white btn" onClick={() => setIsAddingSemester(false)}> Cancel </button>
					<button type="submit" className="submitAdditionButton white btn"> Add </button>
				</form>
			</div>
		}
 		</div>

		{!isAddingSemester && <button id="addSemesterButton" className="btn" onClick={() => setIsAddingSemester(true)}> Add Semester </button>}
		
	</div>

	);
}
